import { setDiscountResponse } from "core/actions/paramsActions";

export default {
	layout: [],
	config: {
		globalConfig: {},
		panels: {},
		views: {},
		panelViews: {},
		properties: {
			default: {},
			theme: {},
		},
		conditions: {}, // { "abc123": "someConditionExternalId" }
		contextProperties: {},
	},
	params: {
		breadcrumbs: [],
		panel: {},
		global: {
			ajaxCallsInProgress: 0,
		},
		refresh: 0, // temp hack to get query components to refresh after the external apollo cache is cleared.
		trackPaginationVal: [],
		cartItems: [],
		quantityInCart: [],
		cartItemsGroupBuy: false,
		discountResponse: null,
		cartUserDetails: null,
		shippableUserDetails: null,
		forumId: null,
	},
	active: {
		panels: [],
		views: [],
		panelState: [],
	},
	schemas: {},
	edit: {
		panelDialog: null,
		active: null, // { type: "view" | "panel", id: string, instance: string }
		changes: 0,
		layout: false,
		enabled: false,
		settings: {},
		popupOpen: false,
	},
	initialization: {
		count: 0,
		threshold: 3,
		done: false,
	},
	dictionary: {},
	user: {
		conditions: {}, // { "someConditionExternalId": true }
		country: null,
		language: null,
		timeZone: null,
		locale: null,
	},
	cart: [],
	itemsToShow: null,
};



// WEBPACK FOOTER //
// ./src/core/reducers/initialState.ts